import React from 'react'
import { useHistory } from 'react-router-dom'
import CButton from 'app/components/Common/CButton'
import { Buttons } from './styles'
import CImage from 'app/components/Common/CImage'
import LOGO from '../../../../assets/socialIcons'

const logos = (logo: any) => (
	<CImage
		src={logo}
		alt="logo"
		width={24}
		height={24}
		resizeMode={'cover'}
		style={{
			marginBottom: 10,
			marginRight: 10,
		}}
	/>
)
const SocialBtns = () => {
	const navigate = useHistory()
	const goTo = (url: any) => {
		navigate.push(url)
	}

	return (
		<Buttons>
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Facebook)}
			/>
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Discord)}
			/>
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Instagram)}
			/>
			<CButton onClick={() => goTo('/trade')} icon={logos(LOGO.Linkin)} />
			<CButton onClick={() => goTo('/trade')} icon={logos(LOGO.Medium)} />
			<CButton onClick={() => goTo('/trade')} icon={logos(LOGO.Reddit)} />
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Telegram)}
			/>
			<CButton onClick={() => goTo('/trade')} icon={logos(LOGO.Tictok)} />
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Twitter)}
			/>
			<CButton
				onClick={() => goTo('/trade')}
				icon={logos(LOGO.Youtube)}
			/>
		</Buttons>
	)
}

export default React.memo(SocialBtns)
